import { number, RequestKind, string } from '@sb/library/base';
import {
    DisplayItemCollection,
    RemittanceOrRefundInputItem,
    RemittanceOrRefundUpdateItem,
    TaxBalanceSummaryRequestItem,
    TaxDisplayItem,
    TaxSearchOptions
} from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace SalesTaxRoutes {
    export const AddRemittance = ApiRoute.Define({
        URL: `remittance`,
        Kind: RequestKind.Post,
        BodyType: RemittanceOrRefundInputItem,
        ResultType: string
    });

    export const Update = ApiRoute.Define({
        URL: (cashID: string) => `remittance/${cashID}`,
        Kind: RequestKind.Put,
        ResultType: string,
        BodyType: RemittanceOrRefundUpdateItem
    });

    export const GetAll = ApiRoute.Define({
        URL: `salestax`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<TaxDisplayItem>
    });

    export const Search = ApiRoute.Define({
        URL: `search/salestax`,
        Kind: RequestKind.Post,
        BodyType: TaxSearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<TaxDisplayItem>
    });

    export const GetBalace = ApiRoute.Define({
        URL: `summary/salestaxbalance`,
        Kind: RequestKind.Post,
        ResultType: number,
        BodyType: TaxBalanceSummaryRequestItem
    });
}
